import z from "zod";
import { pushGtmEvent } from "./utils";

export const checkoutDeniedEventInputSchema = z.object({
  cart_id: z.number(),
  market_code: z.string(),
});

export type CheckoutDeniedEventInput = z.infer<
  typeof checkoutDeniedEventInputSchema
>;

export const checkoutDeniedEventPayloadSchema = z.object({
  event: z.literal("walley_checkout_denied"),
  reference: z.object({
    market_code: z.string(),
    cart_id: z.number(),
  }),
});

export type CheckoutDeniedEventPayload = z.infer<
  typeof checkoutDeniedEventPayloadSchema
>;

export function checkoutDeniedEvent(props: CheckoutDeniedEventInput) {
  if (typeof window === undefined) {
    return;
  }

  try {
    const data = checkoutDeniedEventInputSchema.parse(props);

    if (!data) {
      return;
    }

    pushGtmEvent({
      event: "walley_checkout_denied",
      reference: {
        market_code: data.market_code,
        cart_id: data.cart_id,
      },
    });
  } catch {}
}
